// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._srpYy37UivJUhA5acu4{color:var(--light-blue-60)}.Fsvt3A9oeCwn5Y3AbO9w{margin-right:8px}`, "",{"version":3,"sources":["webpack://./src/shared/ui/TableNew/ui/TableRowHead/HeaderCenterContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,0BAAA,CAEF,sBACE,gBAAA","sourcesContent":[".selectAllButton {\n  color: var(--light-blue-60);\n}\n.text {\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectAllButton": `_srpYy37UivJUhA5acu4`,
	"text": `Fsvt3A9oeCwn5Y3AbO9w`
};
export default ___CSS_LOADER_EXPORT___;
